import { useState, useEffect } from 'react';

/**
 * Hook dla opóźnienia renderowania komponentów do zakończenia hydracji
 * Zapobiega błędom Suspense boundary podczas hydracji
 * 
 * @param {number} checkInterval - Interwał sprawdzania w ms (domyślnie 50ms)
 * @returns {boolean} - true gdy hydracja została zakończona
 */
export const useHydrationDelay = (checkInterval = 50) => {
    const [isHydrated, setIsHydrated] = useState(false);
    
    useEffect(() => {
        // Na serwerze zawsze zwracamy false
        if (typeof window === 'undefined') {
            return;
        }
        
        // Sprawdzanie czy hydracja została zakończona
        const checkHydration = () => {
            if (!window.__IS_HYDRATING) {
                setIsHydrated(true);
            } else {
                setTimeout(checkHydration, checkInterval);
            }
        };
        
        checkHydration();
    }, [checkInterval]);
    
    return isHydrated;
};

export default useHydrationDelay;